import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { PassInstanceStatus } from '../../models/Pass';
import { passMetaChipSx } from './passDetailLayout';

const statusChipColor = (status: PassInstanceStatus): 'success' | 'default' | 'error' | 'warning' | 'info' => {
  switch (status) {
    case 'ACTIVE':
      return 'success';
    case 'EXHAUSTED':
      return 'warning';
    case 'CANCELLED':
      return 'error';
    case 'PENDING_PAYMENT':
      return 'info';
    default:
      return 'default';
  }
};

export interface PassInstanceStatusChipProps {
  status: PassInstanceStatus;
}

/** Outlined instance status chip — same size as type chips on pass surfaces. */
const PassInstanceStatusChip: React.FC<PassInstanceStatusChipProps> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <Chip
      label={t(`userPasses.status.${status}`, status)}
      color={statusChipColor(status)}
      size="small"
      variant="outlined"
      sx={passMetaChipSx}
    />
  );
};

export default PassInstanceStatusChip;
